import React from "react";
import { Icon } from "antd";

export const SuccessMassiveLines = ({ data }) => {
  const validLines = data.filter(
    (item) =>
      Array.isArray(item.packageCodes) &&
      item.packageCodes.length > 0 &&
      (!item.errors || item.errors.length === 0)
  );

  if (validLines.length === 0) return null;

  return (
    <>
      <div className="preregistration-success-result">
        <Icon type="check-circle" />
        <span>
          <b>Se han procesado correctamente {validLines.length} envíos.</b>
        </span>
      </div>
    </>
  );
};
